export default {
  methods: {
    getPaginationData(obj) {
      if (obj.paginationInfo) {
        return obj.paginationInfo;
      }
    },
    standardiseResponse(obj) {
      const standardisedResponse = {};
      for (const key in obj) {
        if (obj[key] instanceof Object) {
          if (obj[key].hasOwnProperty('collection')) {
            standardisedResponse[key] = obj[key].collection;
            continue;
          }

          if (obj[key].hasOwnProperty('edges')) {
            standardisedResponse[key] = obj[key].edges.map((item) => {
              return item.node;
            });
            continue;
          }
        }
        standardisedResponse[key] = obj[key];
      }
      return standardisedResponse;
    },
    flattenItem(flattened, key, value) {
      if (!(value instanceof Object) && !(value instanceof Array)) {
        // Reset primitives to null if they're empty strings
        if ('' !== value) {
          flattened[key] = value;
          return;
        }
        flattened[key] = null;
      }

      if (value instanceof Object && value.hasOwnProperty('id')) {
        flattened[key] = value.id;
        return
      }

      if (value.hasOwnProperty('collection')) {
        flattened[key] = value.collection.map((child) => {
          return child.id;
        });
        return
      }

      if (value.hasOwnProperty('edges')) {
        let arr = value.edges.map((child) => {
          return child.node.id;
        });

        // This may need to be removed - if this property exists then it should be modified accordingly
        // With this method, removal of all existing list items is impossible
        if (1 > arr.length) {
          arr = null;
        }

        flattened[key] = arr;
        return
      }

      if (value instanceof Array && value.length === 0) {
        flattened[key] = [];
        return
      }

      if (value instanceof Array && value[0] !== undefined && value[0].hasOwnProperty('id')) {
        let arr = value.map((child) => {
          return child.id;
        });

        if (1 > arr.length) {
          arr = null;
        }

        flattened[key] = arr;
      }
    },
    flattenRequest(object) {
      const flattened = {};
      if (!object) {
        return false;
      }

      const temp = {...object};

      if (temp.__typename) {
        delete temp.__typename;
      }

      if (temp._id) {
        delete temp._id;
      }

      if (temp.latestEntityStateHistory) {
        delete temp.latestEntityStateHistory;
      }

      for (const key in temp) {
        if (!temp.hasOwnProperty(key)) {
          continue;
        }

        this.flattenItem(flattened, key, temp[key]);
      }

      return flattened;
    },
  },
};
